<template>
  <ButtonComponent
    class="shop-set-button"
    :theme="selected ? 'primary' : 'default'"
    :icon="['fal', 'boxes']"
    v-on="$listeners"
  >
    <template #label>{{ value.name }}</template>
    <template v-if="value.image" #icon>
      <img :src="value.image.url" :alt="value.image.name" />
    </template>
  </ButtonComponent>
</template>

<script>
export default {
  props: {
    value: Object,
    selected: Boolean,
  },
}
</script>

<style lang="scss">
.shop-set-button {
  .elder-button__icon {
    display: flex;
  }

  img {
    $size: 35px;
    width: $size;
    height: $size;
    border-radius: 50%;
    object-fit: cover;
  }
}
</style>
